import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { RobotictableItem } from 'src/app/models';
import { DynamicComponent } from 'src/app/components/base/dynamic.component';
import { PluginService } from 'src/app/services';

@Component({
    selector: 'robotictable-item-component',
    styleUrls: ['robotictable.item.component.less'],
    templateUrl: 'robotictable.item.component.html'
})
export class RoboticTableItemComponent extends DynamicComponent implements OnInit {

    constructor(public pluginService: PluginService) {
        super(pluginService);
    }

    @Input() item: RobotictableItem;

    @Output() delete = new EventEmitter();

    ngOnInit() {
      let field_5_data = JSON.parse(this.item.field_5) || [];
      if(field_5_data){
        for (const key of Object.keys(field_5_data)) {
            this.item[key] = field_5_data[key];
        }

      }
      console.log(field_5_data);
      
    }

    setValue(i , e){
      if(e.checked){
        this.item.field_6 = 1;
      }else{
        this.item.field_6 = 0;
      }
    }

    getValue(){
      return this.item.field_6 == 1 ? true : false;
    }

    toggleCheckbox(item: any, fieldName: string): void {
      item[fieldName] = !item[fieldName];
  }
}
